import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=8add86fe&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8add86fe')) {
      api.createRecord('8add86fe', component.options)
    } else {
      api.reload('8add86fe', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=8add86fe&", function () {
      api.rerender('8add86fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20tqdQE6k5XFX/JS/comp/openstreetmap.vue"
export default component.exports